import { render, staticRenderFns } from "./referralCard.vue?vue&type=template&id=cf6564a8"
import script from "./referralCard.vue?vue&type=script&lang=js"
export * from "./referralCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports